import React from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate, useLocation } from 'react-router-dom';
import NavBar, { NavStatusProvider } from './NavBar/index';
import { DashboardLayoutContext } from './context';

const IFRAME_ROUTE = '/monday-explorer';

const DashboardLayout = ({ children, routes }) => {
  const inIframe = window.self !== window.top;
  const [isNavOpen, setIsNavOpen] = React.useState(!inIframe);
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (inIframe && location.pathname !== IFRAME_ROUTE) {
      navigate(IFRAME_ROUTE, { replace: true });
    }
  }, [inIframe, location.pathname, navigate]);

  return (
    <DashboardLayoutContext.Provider value={{ isNavOpen }}>
      <NavStatusProvider>
        <Box
          sx={{
            backgroundColor: 'background.dark',
            display: 'flex',
            overflow: 'hidden',
            width: '100%',
          }}
        >
          {isNavOpen ? <NavBar onNavClose={() => setIsNavOpen(false)} routes={routes} openMobile /> : null}
          {!isNavOpen && !inIframe && (
            <IconButton
              size="small"
              aria-label="Expand navigation"
              onClick={() => setIsNavOpen(true)}
              disableRipple
              sx={{
                position: 'fixed',
                top: 10,
                left: 10,
                zIndex: (theme) => theme.zIndex.modal + 1,
                backgroundColor: 'background.paper',
                border: (theme) => `1px solid ${theme.palette.divider}`,
                color: 'text.primary',
                lineHeight: 0,
                '&:hover': {
                  backgroundColor: 'action.hover',
                },
              }}
            >
              <MenuIcon fontSize="small" />
            </IconButton>
          )}
          <Box
            sx={{
              display: 'flex',
              flex: '1 1 auto',
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                flex: '1 1 auto',
                height: '100%',
                overflow: 'hidden',
              }}
            >
              {children}
            </Box>
          </Box>
        </Box>
      </NavStatusProvider>
    </DashboardLayoutContext.Provider>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
